import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import WorkspacePermissionManagement from './WorkspacePermission/WorkspacePermissionManagement';
import Modal from './Modals/Modal';
import toast from 'react-hot-toast';
import RequestWorkspaceModal from './Workspaces/RequestWorkspaceModal'; 
import './AdminDashboard.css';

const AdminDashboard = ({userId}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [showWorkspacePermissionModal, setShowWorkspacePermissionModal] = useState(false);
  const [showAllUsersModal, setShowAllUsersModal] = useState(false);
  const [allUsersList, setAllUsersList] = useState([]);
  const [loadingAllUsers, setLoadingAllUsers] = useState(false);
  const [updatingStatusId, setUpdatingStatusId] = useState(null);
  const [showRequestWorkspaceModal, setShowRequestWorkspaceModal] = useState(false);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [workspaces, setWorkspaces] = useState([]);
  const [loadingWorkspaces, setLoadingWorkspaces] = useState(false);
  const [creatingUser, setCreatingUser] = useState(false);
  const [createdUser, setCreatedUser] = useState(null);
  const [createUserForm, setCreateUserForm] = useState({
    Fname: '', Lname: '', UserName: '', Role: '', Email: '', Password: '',
    DefaultWorkspaceId: ''
  });
  const [createUserErrors, setCreateUserErrors] = useState({});
  const navigate = useNavigate();
  const [showEmailOtpModal, setShowEmailOtpModal] = useState(false);
  const [emailOtpData, setEmailOtpData] = useState([]);
  const [loadingEmailOtp, setLoadingEmailOtp] = useState(false);

  const API_URL = process.env.REACT_APP_API_BASE_URL;

  const formatFileSize = (bytes) => {
    console.log('formatFileSize called with:', bytes);
    
    if (bytes === null || bytes === undefined || bytes === 0) return '0 Bytes';
    
    try {
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const result = parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
      console.log('formatFileSize result:', result);
      return result;
    } catch (error) {
      console.error('Error formatting file size:', error);
      return bytes + ' Bytes';
    }
  };

  const getFirstWorkspaceId = () => {
    if (dashboardData?.workspaceOverview?.allWorkspacesWithUsers?.length > 0) {
      return dashboardData.workspaceOverview.allWorkspacesWithUsers[0].id || 
             dashboardData.workspaceOverview.allWorkspacesWithUsers[0].workspaceID;
    }
    return null;
  };


  const closeWorkspacePermissionModal = () => {
    setShowWorkspacePermissionModal(false);
  };

  const handleWorkspacePermissionsClick = () => {
    setShowWorkspacePermissionModal(true);
  };

  const handleAddWorkspaceClick = () => {
    setShowRequestWorkspaceModal(true);
  };

  const handleWorkspaceAdded = () => {
    fetchDashboardMetrics();
    toast.success('Workspace request submitted. Waiting for approval.');
  };

  const calculateStoragePercentage = (storageUsed) => {
    if (!storageUsed) return 0;
    const maxStorage = 10 * 1024 * 1024 * 1024; // 10GB
    return Math.min(Math.round((storageUsed / maxStorage) * 100), 100);
  };

  const fetchDashboardMetrics = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
      
      const response = await fetch(`${apiBaseUrl}/api/Dashboard/GetDashboardMetrics`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.metrics) {
        setDashboardData(result.metrics);
      } else {
        setDashboardData(result);
      }
      
    } catch (err) {
      console.error('Error fetching dashboard metrics:', err);
      setError('Failed to load dashboard data. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const fetchAllUsersList = async () => {
    try {
      setLoadingAllUsers(true);
      const response = await fetch(`${API_URL}/api/UserManagement/GetUsers`);
      if (!response.ok) throw new Error('Failed to fetch users');
      const data = await response.json();
      setAllUsersList(data.users || []);
    } catch (err) {
      console.error('Error fetching all users:', err);
      toast.error('Failed to load users');
    } finally {
      setLoadingAllUsers(false);
    }
  };

  const handleChangeStatus = async (userId, newStatus) => {
    setUpdatingStatusId(userId);
    try {
      const response = await fetch(`${API_URL}/api/UserManagement/ChangeStatus/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          newStatus: newStatus
        })
      });

      if (!response.ok) {
        const err = await response.text();
        throw new Error(err || 'Failed to change status');
      }

      toast.success("Status updated successfully!");
      fetchAllUsersList(); 
      fetchDashboardMetrics(); 
    } catch (err) {
      toast.error(err.message || "Failed to update status");
    } finally {
      setUpdatingStatusId(null);
    }
  };
  const fetchEmailOtpData = async () => {
  try {
    setLoadingEmailOtp(true);
    const response = await fetch(`${API_URL}/api/NewUserOtp/GetAllOtps`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    
    if (!response.ok) throw new Error('Failed to fetch email/OTP data');
    const result = await response.json();
    setEmailOtpData(result.otps || []);
  } catch (err) {
    console.error('Error fetching email/OTP data:', err);
    toast.error('Failed to load email/OTP data');
  } finally {
    setLoadingEmailOtp(false);
  }
};

const handleEmailOtpClick = () => {
  fetchEmailOtpData();
  setShowEmailOtpModal(true);
};

const handleViewEmailOtps = () => {
  fetchEmailOtpData();
  setShowEmailOtpModal(true);
};
  const handleAllUsersClick = () => {
    fetchAllUsersList();
    setShowAllUsersModal(true);
  };  

  const fetchWorkspaces = async () => {
    setLoadingWorkspaces(true);
    try {
      const res = await fetch(`${API_URL}/api/Workspace/GetWorkspace`);
      if (!res.ok) throw new Error();
      const data = await res.json();
      setWorkspaces(data.workspaces || []);
    } catch {
      toast.error('Could not load workspaces');
    } finally {
      setLoadingWorkspaces(false);
    }
  };

  const handleOpenCreateUser = () => {
    setCreateUserForm({ Fname: '', Lname: '', UserName: '', Role: '', Email: '', Password: '', DefaultWorkspaceId: '' });
    setCreateUserErrors({});
    setCreatedUser(null);
    setShowCreateUserModal(true);
    fetchWorkspaces();
  };

  const handleCreateUserChange = (e) => {
    const { name, value } = e.target;
    setCreateUserForm(prev => ({ ...prev, [name]: value }));
    if (createUserErrors[name]) setCreateUserErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateCreateUser = () => {
    const errs = {};
    if (!createUserForm.Fname.trim()) errs.Fname = 'First name is required';
    if (!createUserForm.Lname.trim()) errs.Lname = 'Last name is required';
    if (!createUserForm.UserName.trim()) errs.UserName = 'Username is required';
    if (createUserForm.UserName.length > 25) errs.UserName = 'Max 25 characters';
    if (!createUserForm.Email.trim()) errs.Email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(createUserForm.Email)) errs.Email = 'Invalid email';
    if (!createUserForm.Password) errs.Password = 'Password is required';
    else if (createUserForm.Password.length < 6) errs.Password = 'Min 6 characters';
    return errs;
  };

  const handleCreateUserSubmit = async () => {
    const errs = validateCreateUser();
    if (Object.keys(errs).length > 0) { setCreateUserErrors({ general: Object.values(errs)[0] }); return; }

    const body = new FormData();
    body.append('Fname', createUserForm.Fname);
    body.append('Lname', createUserForm.Lname);
    body.append('UserName', createUserForm.UserName);
    if (createUserForm.Role) body.append('Role', createUserForm.Role);
    body.append('Email', createUserForm.Email);
    body.append('Password', createUserForm.Password);
    if (createUserForm.DefaultWorkspaceId) body.append('DefaultWorkspaceId', createUserForm.DefaultWorkspaceId);

    setCreatingUser(true);
    try {
      const res = await fetch(`${API_URL}/api/UserManagement/CreateUser`, { method: 'POST', body });
      const result = await res.json().catch(() => null);
      if (!res.ok) {
        let errorMsg = result?.title || 'Failed to create user';
        if (result?.errors) {
          errorMsg = Object.values(result.errors).flat().join(' ');
        } else if (result?.message) {
          errorMsg = result.message;
        }
        setCreateUserErrors({ general: errorMsg });
        return;
      }
      setCreatedUser(result?.user || createUserForm);
      fetchDashboardMetrics();
    } catch {
      setCreateUserErrors({ general: 'An unexpected error occurred' });
    } finally {
      setCreatingUser(false);
    }
  };

  useEffect(() => {
    fetchDashboardMetrics();
  }, []);

  const stats = dashboardData ? [
    { 
      label: 'Total Workspaces', 
      value: dashboardData.workspaceOverview?.totalWorkspaces?.toString() || '0', 
      change: '+12%', 
      icon: 'fas fa-building', 
      color: '#3B82F6',
      onClick: null
    },
    { 
      label: 'Active Users', 
      value: dashboardData.userStatistics?.activeUsers?.toString() || '0', 
      change: '+8%', 
      icon: 'fas fa-users', 
      color: '#10B981',
      onClick: handleAllUsersClick
    },
    { 
      label: 'Email & OTP Logs', 
      value: emailOtpData.length?.toString() || '0', 
      change: '+0%', 
      icon: 'fas fa-envelope', 
      color: '#EC4899',
      onClick: handleViewEmailOtps  
    },
    { 
      label: 'Total Notes', 
      value: dashboardData.notesStatistics?.totalNotes?.toString() || '0', 
      change: '+23%', 
      icon: 'fas fa-sticky-note', 
      color: '#8B5CF6',
      onClick: null
    },
    { 
      label: 'Total Users', 
      value: dashboardData.userStatistics?.totalUsers?.toString() || '0', 
      change: '+15%', 
      icon: 'fas fa-user-plus', 
      color: '#F59E0B',
      onClick: null
    },
    { 
      label: 'Total Attachments', 
      value: dashboardData.attachments?.totalAttachments?.toString() || '0', 
      change: '+18%', 
      icon: 'fas fa-paperclip', 
      color: '#EF4444',
      onClick: null
    },
    { 
      label: 'Storage Used', 
      value: `${calculateStoragePercentage(dashboardData.storageUsage?.totalStorageUsed)}%`, 
      change: '+4%', 
      icon: 'fas fa-database', 
      color: '#6366F1',
      onClick: null
    },
  ] : [
    { label: 'Total Workspaces', value: '0', change: '+0%', icon: 'fas fa-building', color: '#3B82F6', onClick: null },
    { label: 'Active Users', value: '0', change: '+0%', icon: 'fas fa-users', color: '#10B981', onClick: null },
    { label: 'Total Notes', value: '0', change: '+0%', icon: 'fas fa-sticky-note', color: '#8B5CF6', onClick: null },
    { label: 'Total Users', value: '0', change: '+0%', icon: 'fas fa-user-plus', color: '#F59E0B', onClick: null },
    { label: 'Total Attachments', value: '0', change: '+0%', icon: 'fas fa-paperclip', color: '#EF4444', onClick: null },
    { label: 'Storage Used', value: '0%', change: '+0%', icon: 'fas fa-database', color: '#6366F1', onClick: null },
  ];

  const workspaceData = dashboardData?.workspaceOverview?.allWorkspacesWithUsers?.map((workspace, index) => {
    const topWorkspace = dashboardData?.workspaceOverview?.top10Workspaces?.find(w => w.name === workspace.name);
    return {
      name: workspace.name,
      users: workspace.usersCount || 0,
      projects: topWorkspace?.notesCount || 0,
      status: 'active'
    };
  }) || [
    { name: 'Loading...', users: 0, projects: 0, status: 'active' },
  ];

  if (loading) {
    return (
      <div className="admin-dashboard-container">
        <div className="admin-dashboard-loading">
          <i className="fas fa-spinner fa-spin fa-3x"></i>
          <p>Loading dashboard data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-dashboard-container">
        <div className="admin-dashboard-error">
          <div className="error-message">
            <i className="fas fa-exclamation-triangle fa-3x"></i>
            <h3>Error Loading Dashboard</h3>
            <p>{error}</p>
            <button className="admin-btn-primary" onClick={() => window.location.reload()}>
              <i className="fas fa-redo"></i> Reload Page
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard-container">
      <div className={`admin-main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <nav className="admin-navbar">
          <div className="admin-navbar-left">
            <h1>Admin Dashboard</h1>
            <div className="admin-breadcrumb">
              <span>Admin</span>
              <i className="fas fa-chevron-right" />
              <span className="admin-active">Dashboard</span>
            </div>
          </div>
          
          <div className="admin-navbar-right">
            <button className="admin-nav-btn" title="Notifications">
              <i className="fas fa-bell" />
              <span className="admin-notification-badge">3</span>
            </button>
            
            <button className="admin-nav-btn" title="Search">
              <i className="fas fa-search" />
            </button>
            
            <button 
              className="admin-nav-btn admin-home-btn" 
              onClick={() => navigate('/')}
              title="Back to Home"
            >
              <i className="fas fa-home" />
              <span>Back to Home</span>
            </button>
            
            
          </div>
        </nav>

        <div className="admin-dashboard-content">
          <div className="admin-welcome-banner">
            <div className="admin-welcome-text">
              <h2>Welcome back, Admin!</h2>
              <p>Here's what's happening with your platform today.</p>
            </div>
            <div className="admin-welcome-actions">
              <button className="admin-btn-primary" onClick={handleAddWorkspaceClick}>
                <i className="fas fa-plus" /> Add New Workspace
              </button>
              <button className="admin-btn-primary" onClick={handleOpenCreateUser}>
                <i className="fas fa-user-plus" /> Create User
              </button>
              <button
                className="admin-btn-secondary"
                onClick={handleWorkspacePermissionsClick}
              >
                <i className="fas fa-user-shield" /> Workspace Permissions
              </button>
              <button className="admin-btn-secondary">
                <i className="fas fa-download" /> Generate Report
              </button>
            </div>
          </div>

          <div className="admin-stats-grid">
            {stats.map((stat, index) => (
              <div 
                className={`admin-stat-card ${stat.onClick ? 'clickable' : ''}`} 
                key={index}
                onClick={stat.onClick}
                style={{ cursor: stat.onClick ? 'pointer' : 'default' }}
              >
                <div className="admin-stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                  <i className={stat.icon} />
                </div>
                <div className="admin-stat-info">
                  <div className="admin-stat-value">{stat.value}</div>
                  <div className="admin-stat-label">{stat.label}</div>
                </div>
                <div className={`admin-stat-change ${stat.change.startsWith('+') ? 'positive' : 'negative'}`}>
                  {stat.change}
                </div>
              </div>
            ))}
          </div>

          <div className="admin-content-grid">
            <div className="admin-content-card">
              <div className="admin-card-header">
                <h3><i className="fas fa-building" /> Workspace Overview</h3>
                <button className="admin-btn-text">Manage All</button>
              </div>
              <div className="admin-card-body">
                <div className="admin-workspace-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Workspace Name</th>
                        <th>Users</th>
                        <th>Notes</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {workspaceData.map((workspace, index) => (
                        <tr key={index}>
                          <td>
                            <div className="admin-workspace-name">
                              <div className="admin-workspace-color" style={{ backgroundColor: `hsl(${index * 60}, 70%, 60%)` }} />
                              {workspace.name}
                            </div>
                          </td>
                          <td>{workspace.users}</td>
                          <td>{workspace.projects}</td>
                          <td>
                            <span className={`admin-status-badge ${workspace.status}`}>
                              {workspace.status}
                            </span>
                          </td>
                          <td>
                            <button className="admin-table-action-btn" title="Edit">
                              <i className="fas fa-edit" />
                            </button>
                            <button className="admin-table-action-btn" title="View">
                              <i className="fas fa-eye" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="admin-content-card">
              <div className="admin-card-header">
                <h3><i className="fas fa-chart-line" /> Platform Growth</h3>
                <div className="admin-time-filter">
                  <button className="admin-time-btn active">7D</button>
                  <button className="admin-time-btn">1M</button>
                  <button className="admin-time-btn">6M</button>
                  <button className="admin-time-btn">1Y</button>
                </div>
              </div>
              <div className="admin-card-body">
                <div className="admin-chart-placeholder">
                  <div className="admin-chart-lines">
                    {[0, 1, 2, 3, 4, 5].map((line) => (
                      <div key={line} className="admin-chart-line" style={{ height: `${40 + Math.random() * 60}%` }}>
                        <div className="admin-chart-bar" />
                      </div>
                    ))}
                  </div>
                  <div className="admin-chart-labels">
                    <span>Mon</span>
                    <span>Tue</span>
                    <span>Wed</span>
                    <span>Thu</span>
                    <span>Fri</span>
                    <span>Sat</span>
                  </div>
                </div>
                <div className="admin-chart-legend">
                  <div className="admin-legend-item">
                    <div className="admin-legend-color" style={{ backgroundColor: '#3B82F6' }} />
                    <span>New Users</span>
                  </div>
                  <div className="admin-legend-item">
                    <div className="admin-legend-color" style={{ backgroundColor: '#10B981' }} />
                    <span>Active Workspaces</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="admin-content-card">
              <div className="admin-card-header">
                <h3><i className="fas fa-server" /> System Status</h3>
                <button className="admin-btn-text">Refresh</button>
              </div>
              <div className="admin-card-body">
                <div className="admin-system-status">
                  <div className="admin-status-item">
                    <div className="admin-status-info">
                      <div className="admin-status-name">API Server</div>
                      <div className="admin-status-desc">Backend Services</div>
                    </div>
                    <div className="admin-status-indicator active">
                      <div className="admin-status-dot" />
                      <span>Online</span>
                    </div>
                  </div>
                  
                  <div className="admin-status-item">
                    <div className="admin-status-info">
                      <div className="admin-status-name">Database</div>
                      <div className="admin-status-desc">SQL Server</div>
                    </div>
                    <div className="admin-status-indicator active">
                      <div className="admin-status-dot" />
                      <span>Healthy</span>
                    </div>
                  </div>
                  
                  <div className="admin-status-item">
                    <div className="admin-status-info">
                      <div className="admin-status-name">Storage</div>
                      <div className="admin-status-desc">
                        Total: {formatFileSize(dashboardData?.storageUsage?.totalStorageUsed)}
                      </div>
                    </div>
                    <div className="admin-status-indicator warning">
                      <div className="admin-status-dot" />
                      <span>{calculateStoragePercentage(dashboardData?.storageUsage?.totalStorageUsed)}% Used</span>
                    </div>
                  </div>
                  
                 
                </div>
                
                <div className="admin-system-actions">
                  <button className="admin-btn-outline">
                    <i className="fas fa-redo" /> Restart Services
                  </button>
                  <button className="admin-btn-outline">
                    <i className="fas fa-file-alt" /> View Logs
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Request Workspace Modal (direct, no OTP) */}
      <RequestWorkspaceModal
        isOpen={showRequestWorkspaceModal}
        onClose={() => setShowRequestWorkspaceModal(false)}
        ownerUserID={userId}
        onWorkspaceAdded={handleWorkspaceAdded}
      />

      {/* Workspace Permissions Modal */}
      {showWorkspacePermissionModal && (
        <Modal
          isOpen={showWorkspacePermissionModal}
          onClose={closeWorkspacePermissionModal}
          title="Workspace Permissions"
          className="modal-lg"
        >
          <WorkspacePermissionManagement 
            defId={getFirstWorkspaceId()} 
            userId={userId}
            isAdminDashboard={true}
            dashboardData={dashboardData} 
          />
        </Modal>
      )}

      {/* Create User Modal */}
      {showCreateUserModal && (
        <Modal
          isOpen={showCreateUserModal}
          onClose={() => setShowCreateUserModal(false)}
          title="Create New User"
        >
          {createdUser ? (
            <div className="settings-form">
              <div className="success-message" style={{ marginBottom: '20px' }}>
                <i className="fas fa-check-circle"></i> User created successfully!
              </div>
              <div className="settings-form user-form-grid">
                <div className="form-group">
                  <label>Full Name:</label>
                  <input type="text" readOnly value={`${createdUser.fname || createUserForm.Fname} ${createdUser.lname || createUserForm.Lname}`} />
                </div>
                <div className="form-group">
                  <label>Username:</label>
                  <input type="text" readOnly value={createdUser.userName || createUserForm.UserName} />
                </div>
                <div className="form-group">
                  <label>Email:</label>
                  <input type="text" readOnly value={createdUser.email || createUserForm.Email} />
                </div>
                <div className="form-group">
                  <label>Role:</label>
                  <input type="text" readOnly value={createdUser.role || createUserForm.Role || '—'} />
                </div>
                <div className="form-group">
                  <label>Default Workspace:</label>
                  <input type="text" readOnly value={
                    workspaces.find(ws => ws.id === parseInt(createdUser.defaultWorkspaceId || createUserForm.DefaultWorkspaceId))?.name || '—'
                  } />
                </div>
                {createdUser.id && (
                  <div className="form-group">
                    <label>User ID:</label>
                    <input type="text" readOnly value={createdUser.id} />
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn-primary" onClick={() => { setCreatedUser(null); setCreateUserForm({ Fname: '', Lname: '', UserName: '', Role: '', Email: '', Password: '', DefaultWorkspaceId: '' }); }}>
                  Create Another
                </button>
                <button className="btn-close" onClick={() => { setShowCreateUserModal(false); setCreatedUser(null); }}>
                  Close
                </button>
              </div>
            </div>
          ) : (
            <div className="settings-form">
              <form onSubmit={(e) => { e.preventDefault(); handleCreateUserSubmit(); }}>
                <div className="settings-form user-form-grid">
                  <div className="form-group">
                    <label>First Name:</label>
                    <input type="text" name="Fname" value={createUserForm.Fname} onChange={handleCreateUserChange} placeholder="Enter first name" required />
                  </div>
                  <div className="form-group">
                    <label>Last Name:</label>
                    <input type="text" name="Lname" value={createUserForm.Lname} onChange={handleCreateUserChange} placeholder="Enter last name" required />
                  </div>
                  <div className="form-group">
                    <label>Username:</label>
                    <input type="text" name="UserName" value={createUserForm.UserName} onChange={handleCreateUserChange} placeholder="Enter username" maxLength={25} required />
                  </div>
                  <div className="form-group">
                    <label>Role:</label>
                    <select name="Role" value={createUserForm.Role} onChange={handleCreateUserChange}>
                      <option value="">Select Role</option>
                      <option value="Admin">Admin</option>
                      <option value="Manager">Manager</option>
                      <option value="User">User</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Email:</label>
                    <input type="email" name="Email" value={createUserForm.Email} onChange={handleCreateUserChange} placeholder="Enter email" required />
                  </div>
                  <div className="form-group">
                    <label>Password:</label>
                    <input type="password" name="Password" value={createUserForm.Password} onChange={handleCreateUserChange} placeholder="Enter password" required />
                  </div>
                  <div className="form-group">
                    <label>Default Workspace:</label>
                    <select name="DefaultWorkspaceId" value={createUserForm.DefaultWorkspaceId} onChange={handleCreateUserChange} disabled={loadingWorkspaces}>
                      <option value="">{loadingWorkspaces ? 'Loading...' : 'Select Workspace'}</option>
                      {workspaces.map(ws => (
                        <option key={ws.id} value={ws.id}>{ws.name} ({ws.friendlyId || `WS-${ws.id}`})</option>
                      ))}
                    </select>
                  </div>
                </div>
                {createUserErrors.general && <div className="error-message">{createUserErrors.general}</div>}
                <div className="modal-footer">
                  <button
                    className="btn-primary"
                    type="submit"
                    disabled={creatingUser || !createUserForm.Fname || !createUserForm.Lname || !createUserForm.UserName || !createUserForm.Email || !createUserForm.Password}
                  >
                    {creatingUser ? 'Creating...' : 'Create User'}
                  </button>
                  <button className="btn-close" type="button" onClick={() => setShowCreateUserModal(false)} disabled={creatingUser}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          )}
        </Modal>
      )}

      {/* All Users Modal */}
      {showAllUsersModal && (
        <Modal
          isOpen={showAllUsersModal}
          onClose={() => setShowAllUsersModal(false)}
          title={`All Users (${allUsersList.length})`}
          className="modal-lg"
        >
          <div className="all-users-modal-container">
            <input
              type="text"
              placeholder="Search by name, username, or email..."
              className="all-users-search-input"
              onChange={(e) => {
                const searchTerm = e.target.value.toLowerCase();
                const rows = document.querySelectorAll('.user-row-modal');
                rows.forEach(row => {
                  const text = row.textContent.toLowerCase();
                  row.style.display = text.includes(searchTerm) ? '' : 'none';
                });
              }}
            />
            
            {loadingAllUsers ? (
              <div className="all-users-loading-state">
                <i className="fas fa-spinner fa-spin fa-2x" />
                <p>Loading users...</p>
              </div>
            ) : allUsersList.length === 0 ? (
              <div className="all-users-empty-state">
                <i className="fas fa-users fa-3x" />
                <p>No users found</p>
              </div>
            ) : (
              <div className="all-users-table-wrapper">
                <table className="all-users-data-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Username</th>
                      <th>Email</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allUsersList.map((user) => (
                      <tr key={user.id} className="user-row-modal">
                        <td>
                          <div className="user-name-display">
                            {user.fname} {user.lname}
                          </div>
                          <div className="user-id-display">ID: {user.id}</div>
                        </td>
                        <td>
                          <span className="user-username-display">@{user.userName}</span>
                        </td>
                        <td>{user.email}</td>
                        <td>
                          <span className={`user-status-indicator ${user.status === 1 ? 'status-active' : 'status-inactive'}`}>
                            {user.status === 1 ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        <td>
                          <select
                            className="user-status-dropdown"
                            value={user.status}
                            onChange={(e) => handleChangeStatus(user.id, parseInt(e.target.value))}
                            disabled={updatingStatusId === user.id}
                          >
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="all-users-modal-footer">
              <button
                className="all-users-close-button"
                onClick={() => setShowAllUsersModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}
     
      {showEmailOtpModal && (
        <Modal
          isOpen={showEmailOtpModal}
          onClose={() => setShowEmailOtpModal(false)}
          title="Email & OTP Generation Logs"
          className="modal-lg"
        >
          <div className="email-otp-modal-container">
            <input
              type="text"
              placeholder="Search by email or OTP..."
              className="email-otp-search-input"
              onChange={(e) => {
                const searchTerm = e.target.value.toLowerCase();
                const rows = document.querySelectorAll('.email-otp-row');
                rows.forEach(row => {
                  const text = row.textContent.toLowerCase();
                  row.style.display = text.includes(searchTerm) ? '' : 'none';
                });
              }}
            />
            
            {loadingEmailOtp ? (
              <div className="email-otp-loading-state">
                <i className="fas fa-spinner fa-spin fa-2x" />
                <p>Loading email/OTP data...</p>
              </div>
            ) : emailOtpData.length === 0 ? (
              <div className="email-otp-empty-state">
                <i className="fas fa-envelope fa-3x" />
                <p>No OTP records found</p>
              </div>
            ) : (
              <div className="email-otp-table-wrapper">
                <table className="email-otp-data-table">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>OTP Code</th>
                      <th>Generated At</th>
                      <th>Expires At</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {emailOtpData.map((otp, index) => (
                      <tr key={index} className="email-otp-row">
                        <td>{otp.email}</td>
                        <td>
                          <code className="otp-code">{otp.code}</code>
                        </td>
                        <td>{new Date(otp.createdAt).toUTCString()}</td>
                        <td>{new Date(otp.expiresAt).toUTCString()}</td>
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="email-otp-modal-footer">
              <button
                className="email-otp-close-button"
                onClick={() => setShowEmailOtpModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default AdminDashboard;